import { createClient } from '@meteor/rpc/client';
import { AdminClient } from './src/apis/admin';

export let createAdminClient = ({ host }: { host: string }) =>
  createClient<AdminClient>({ endpoint: `${host}/admin` });

export type { AdminClient };
